// advancedModal.js
(function($, window, document) {
  "use strict";

  $(function() {
    // advanced options modal

    // templates for localized data edit section
    var adminPanelInitialized = false;
    var $localDataInput = $("section.localDataInput");
    var localizedDataMarkup = {};
    localizedDataMarkup.avgGroundWaterTemp = $localDataInput
      .children("div")
      .children("div.form-group")
      .children("input#avgGroundWaterTemp")
      .next()
      .html();
    localizedDataMarkup.winterGroundWaterTemp = $localDataInput
      .children("div")
      .children("div.form-group")
      .children("input#winterGroundWaterTemp")
      .next()
      .html();
    localizedDataMarkup.electricityPrice = $localDataInput
      .children("div")
      .children("div.form-group")
      .children("input#electricityPrice")
      .next()
      .html();
    localizedDataMarkup.naturalGasPrice = $localDataInput
      .children("div")
      .children("div.form-group")
      .children("input#naturalGasPrice")
      .next()
      .html();
    localizedDataMarkup.propanePrice = $localDataInput
      .children("div")
      .children("div.form-group")
      .children("input#propanePrice")
      .next()
      .html();

    window.editWindowOpen = false;

    $("#modalAdvancedOptions").on("show.bs.modal", function(e) {
      //var inMobile = $('.modalAdvancedOptions').css('display') == 'block';
      ga("send", "event", "PST - Modal Open", "Advanced Dialog");

      AdvancedModalReset(true);
      var $installationText = $("section.installationText");
      var $installationInput = $("section.installationInput");
      var $powerTypeInput = $("#powerType");
      var temp = "";
      if (resultsObj.prices.City == "") {
        $installationText
          .children("div")
          .children("div")
          .children('h3:contains("Location")')
          .next()
          .text("National Averages");
      } else {
        $installationText
          .children("div")
          .children("div")
          .children('h3:contains("Location")')
          .next()
          .text(
            resultsObj.prices.City +
              ", " +
              resultsObj.prices.State +
              " " +
              resultsObj.prices.ZipCode
          );
      }
      $installationInput
        .children("div.installationZipCode")
        .children("input")
        .val(resultsObj.prices.ZipCode);
      switch (resultsObj.request.FuelType) {
        case "Electric":
          temp = "Electric";
          break;
        case "NaturalGas":
          temp = "Natural Gas";
          break;
        default:
          temp = "Propane";
          break;
      }
      $powerTypeInput.val(resultsObj.request.FuelType);
      $installationText
        .children("div")
        .children("div")
        .children('h3:contains("Power Source")')
        .next()
        .text(temp);
      $installationInput
        .children("div.notOnProductPageInput")
        .children("div.powerSourceInput")
        .children("select")
        .val(resultsObj.request.FuelType);
      //
      switch (resultsObj.request.VentType) {
        case "StandardVent":
          temp = "Standard or Atmospheric";
          break;
        case "DirectVent":
          temp = "Direct";
          break;
        case "PowerVent":
          temp = "Power";
          break;
        case "PowerDirectVent":
          temp = "Power Direct";
          break;
        default:
          temp = "I'm Not Sure";
          break;
      }
      $("#venting").val(resultsObj.request.VentType);
      // if fueltype=electric, disable venting
      if (resultsObj.request.FuelType == "Electric") {
        temp = "I'm Not Sure";
        $installationText
          .children("div")
          .children("div")
          .children('h3:contains("Venting")')
          .next()
          .text(temp);
        $installationInput
          .children("div.notOnProductPageInput")
          .children("div.ventingTypeInput")
          .children("select")
          .val(resultsObj.request.VentType);
        $installationInput
          .children("div.notOnProductPageInput")
          .children("div.ventingTypeInput")
          .children("select")
          .attr("disabled", "disabled");
      } else {
        $installationText
          .children("div")
          .children("div")
          .children('h3:contains("Venting")')
          .next()
          .text(temp);
        $installationInput
          .children("div.notOnProductPageInput")
          .children("div.ventingTypeInput")
          .children("select")
          .val(resultsObj.request.VentType);
        $installationInput
          .children("div.notOnProductPageInput")
          .children("div.ventingTypeInput")
          .children("select")
          .removeAttr("disabled");
      }
      //
      temp =
        resultsObj.request.TankHeight +
        '" x ' +
        resultsObj.request.TankWidth +
        '" x ' +
        resultsObj.request.TankDiameter +
        '"';
      $installationText
        .children("div")
        .children("div")
        .children('h3:contains("Available Space")')
        .next()
        .text(temp);
      $installationInput
        .children("div.notOnProductPageInput")
        .children("div.dimension-group")
        .children("div")
        .children("input#installationSpaceH")
        .val(resultsObj.request.TankHeight);
      $installationInput
        .children("div.notOnProductPageInput")
        .children("div.dimension-group")
        .children("div")
        .children("input#installationSpaceW")
        .val(resultsObj.request.TankWidth);
      $installationInput
        .children("div.notOnProductPageInput")
        .children("div.dimension-group")
        .children("div")
        .children("input#installationSpaceD")
        .val(resultsObj.request.TankDiameter);
      $("#installationSpaceHResult").val(resultsObj.request.TankHeight);
      $("#installationSpaceWResult").val(resultsObj.request.TankWidth);
      $("#installationSpaceDResult").val(resultsObj.request.TankDiameter);
      //
      var $assumptionsText = $("section.assumptionsText");
      var $assumptionsInput = $("section.assumptionsInput");
      //
      $assumptionsText
        .children("div")
        .children("div")
        .children('h3:contains("Shower Flow Rate")')
        .next()
        .text(resultsObj.request.ShowerFlowRate + " gallons/minute");
      $assumptionsInput
        .children("div")
        .children("div.form-group")
        .children("input#drawRateShower")
        .val(resultsObj.request.ShowerFlowRate);
      //
      $assumptionsText
        .children("div")
        .children("div")
        .children('h3:contains("Bathtub Flow Rate")')
        .next()
        .text(resultsObj.request.BathTubFlowRate + " gallons/minute");
      $assumptionsInput
        .children("div")
        .children("div.form-group")
        .children("input#drawRateTub")
        .val(resultsObj.request.BathTubFlowRate);
      //
      $assumptionsText
        .children("div")
        .children("div")
        .children('h3:contains("Tank Set Point")')
        .next()
        .text(resultsObj.request.TankTemp + "°");
      $assumptionsInput
        .children("div")
        .children("div.form-group")
        .children("input#tankWaterTemp")
        .val(resultsObj.request.TankTemp);
      //
      $assumptionsText
        .children("div")
        .children("div")
        .children('h3:contains("Average Air Temperature")')
        .next()
        .text(resultsObj.request.AirTemp + "°");
      $assumptionsInput
        .children("div")
        .children("div.form-group")
        .children("input#avgAirTemp")
        .val(resultsObj.request.AirTemp);
      //
      // $assumptionsText.children('dl').children('dt:contains("Average Groundwater Temperature")').next().text(resultsObj.request.GroundWaterTemp + "°");
      // $assumptionsInput.children('div').children('div.form-group').children('input#avgGroundWaterTemp').val(resultsObj.request.GroundWaterTemp);
      //
      $assumptionsText
        .children("div")
        .children("div")
        .children('h3:contains("Average Hot Water Usage")')
        .next()
        .text(resultsObj.request.DailyHotWater + " gallons");
      $assumptionsInput
        .children("div")
        .children("div.form-group")
        .children("input#dailyHotWater")
        .val(resultsObj.request.DailyHotWater);
      //
      if (resultsObj.request.MobileHomeInstallation === true) {
        $assumptionsText
          .children("div")
          .children("div")
          .children('h3:contains("Mobile Home")')
          .next()
          .html("Yes");
        $assumptionsInput
          .children("div")
          .children("div.form-group")
          .children("select#mobileHome")
          .val("Yes");
      } else {
        $assumptionsText
          .children("div")
          .children("div")
          .children('h3:contains("Mobile Home")')
          .next()
          .html("No");
        $assumptionsInput
          .children("div")
          .children("div.form-group")
          .children("select#mobileHome")
          .val("No");
      }

      window.UpdateLocalDataFields();
    });

    window.UpdateLocalDataFields = function UpdateLocalDataFields() {
      var $localDataText = $("section.localDataText");
      var $localDataInput = $("section.localDataInput");
      //
      //
      var localGroundWaterTemp = adminPanelInitialized
        ? resultsObj.request.GroundWaterTemp
        : resultsObj.prices.AverageGroundWaterTemp;
      $localDataText
        .children("div")
        .children("div")
        .children('h3:contains("Cold Water (avg)")')
        .next()
        .text(localGroundWaterTemp + "°");
      var $input = $localDataInput
        .children("div")
        .children("div.form-group")
        .children("input#avgGroundWaterTemp");
      $input.val(resultsObj.request.GroundWaterTemp);
      FillInLocalDataTemplate(
        $input,
        "{{GROUNDWATERTEMP}}",
        resultsObj.prices.AverageGroundWaterTemp,
        localizedDataMarkup.avgGroundWaterTemp,
        "{{CITYSTATE}}"
      );
      //
      var localWinterGroundWaterTemp = adminPanelInitialized
        ? resultsObj.request.WinterGroundWaterTemp
        : resultsObj.prices.WinterGroundWaterTemp;
      $localDataText
        .children("div")
        .children("div")
        .children('h3:contains("Cold Water (winter)")')
        .next()
        .text(localWinterGroundWaterTemp + "°");
      //$localDataInput.children('div').children('div.form-group').children('input#winterGroundWaterTemp').val(resultsObj.request.WinterGroundWaterTemp);
      $input = $localDataInput
        .children("div")
        .children("div.form-group")
        .children("input#winterGroundWaterTemp");
      $input.val(resultsObj.request.WinterGroundWaterTemp);
      FillInLocalDataTemplate(
        $input,
        "{{WINTERWATERTEMP}}",
        resultsObj.prices.WinterGroundWaterTemp,
        localizedDataMarkup.winterGroundWaterTemp,
        "{{CITYSTATE}}"
      );
      //
      switch (resultsObj.request.LocalEmissionsRequirements) {
        case "LowNox":
          $localDataText
            .children("div")
            .children("div")
            .children('h3:contains("Emissions")')
            .next()
            .text("Low NOx");
          break;
        case "UltraLowNox":
          $localDataText
            .children("div")
            .children("div")
            .children('h3:contains("Emissions")')
            .next()
            .text("Ultra-Low NOx");
          break;
        default:
          $localDataText
            .children("div")
            .children("div")
            .children('h3:contains("Emissions")')
            .next()
            .text("No Emissions Requirements");
          break;
      }
      $localDataInput
        .children("div")
        .children("div.form-group")
        .children("select#emission")
        .val(resultsObj.request.LocalEmissionsRequirements);
      //
      var localElectricity = adminPanelInitialized
        ? resultsObj.request.Electricity
        : resultsObj.prices.ElectricPricePerKwh;
      if (requestParms.electricityPrice) {
        localElectricity = requestParms.electricityPrice;
      }
      $localDataText
        .children("div")
        .children("div")
        .children('h3:contains("Electricity")')
        .next()
        .text("$" + MathRound(localElectricity, 3) + "/kWh");
      //$localDataInput.children('div').children('div.form-group').children('input#electricityPrice').val(MathRound(resultsObj.request.Electricity, 3));
      $input = $localDataInput
        .children("div")
        .children("div.form-group")
        .children("input#electricityPrice");
      $input.val(MathRound(resultsObj.request.Electricity, 3));
      FillInLocalDataTemplate(
        $input,
        "{{ELECTRICITYPRICE}}",
        MathRound(resultsObj.prices.ElectricPricePerKwh, 3),
        localizedDataMarkup.electricityPrice,
        "{{STATE}}"
      );
      //
      var localNaturalGasCost = adminPanelInitialized
        ? resultsObj.request.NaturalGasCost
        : resultsObj.prices.GasPricePerMfc;
      if (requestParms.naturalGasPrice) {
        localNaturalGasCost = requestParms.naturalGasPrice;
      }
      $localDataText
        .children("div")
        .children("div")
        .children('h3:contains("Natural Gas")')
        .next()
        .text("$" + MathRound(localNaturalGasCost, 3) + "/Mcf");
      //$localDataInput.children('div').children('div.form-group').children('input#naturalGasPrice').val(MathRound(resultsObj.request.NaturalGasCost, 3));
      $input = $localDataInput
        .children("div")
        .children("div.form-group")
        .children("input#naturalGasPrice");
      $input.val(MathRound(resultsObj.request.NaturalGasCost, 3));
      FillInLocalDataTemplate(
        $input,
        "{{NATURALGASPRICE}}",
        MathRound(resultsObj.prices.GasPricePerMfc, 3),
        localizedDataMarkup.naturalGasPrice,
        "{{STATE}}"
      );
      //
      var localPropaneCost = adminPanelInitialized
        ? resultsObj.request.PropaneCost
        : resultsObj.prices.PropanePricePerGal;
      if (requestParms.propanePrice) {
        localPropaneCost = requestParms.propanePrice;
      }
      $localDataText
        .children("div")
        .children("div")
        .children('h3:contains("Propane")')
        .next()
        .text("$" + MathRound(localPropaneCost, 3) + "/gallon");
      //$localDataInput.children('div').children('div.form-group').children('input#propanePrice').val(MathRound(resultsObj.request.PropaneCost, 3));
      $input = $localDataInput
        .children("div")
        .children("div.form-group")
        .children("input#propanePrice");
      $input.val(MathRound(resultsObj.request.PropaneCost, 3));
      FillInLocalDataTemplate(
        $input,
        "{{PROPANEGASPRICE}}",
        MathRound(resultsObj.prices.PropanePricePerGal, 3),
        localizedDataMarkup.propanePrice,
        "{{STATE}}"
      );

      adminPanelInitialized = true;
    };

    var FillInLocalDataTemplate = function FillInLocalDataTemplate(
      $input,
      valueTag,
      value,
      markup,
      cityStateTag
    ) {
      //$input = $localDataInput.children('div').children('div.form-group').children('input#winterGroundWaterTemp');
      markup = StringReplace(valueTag, markup, value);
      if (resultsObj.prices.City == "") {
        markup = StringReplace("{{INUSING}}", markup, "using");
        markup = StringReplace(cityStateTag, markup, "National Averages");
      } else {
        markup = StringReplace("{{INUSING}}", markup, "in");
        var cityState =
          resultsObj.prices.City + ", " + resultsObj.prices.StateAbbr;
        if (cityStateTag == "{{STATE}}")
          cityState = resultsObj.prices.StateAbbr;
        markup = StringReplace(cityStateTag, markup, cityState);
      }
      $input.next().html(markup);
    };

    var SetSubmitRequestValues = function SetSubmitRequestValues(section) {
      // if (section.indexOf('installation') >= 0) {
      var $installationInput = $("section.installationInput");
      var powerType = $("#powerType").val();
      //requestParms.zipCode = $installationInput.children('div.installationZipCode').children('input').val();
      requestParms.energySource = $("#powerType").val();
      if (powerType === "Electric") {
        delete requestParms.ventingPreference;
        $("section.installationText")
          .find('h3:contains("Venting")')
          .next()
          .text("I'm Not Sure");
      }
      requestParms.spaceHeight = $('#installationSpaceHResult').val();
      requestParms.spaceWidth = $('#installationSpaceWResult').val();
      requestParms.spaceDepth = $('#installationSpaceDResult').val();
      var $assumptionsInput = $("section.assumptionsInput");
      requestParms.showerFlowRate = $assumptionsInput
        .children("div")
        .children("div.form-group")
        .children("input#drawRateShower")
        .val();
      requestParms.BathTubFlowRate = $assumptionsInput
        .children("div")
        .children("div.form-group")
        .children("input#drawRateTub")
        .val();
      requestParms.TankTemp = $assumptionsInput
        .children("div")
        .children("div.form-group")
        .children("input#tankWaterTemp")
        .val();
      requestParms.AverageAirTemp = $assumptionsInput
        .children("div")
        .children("div.form-group")
        .children("input#avgAirTemp")
        .val();
      //requestParms.AverageGroundWaterTemp = $assumptionsInput.children('div').children('div.form-group').children('input#avgGroundWaterTemp').val();
      requestParms.DailyHotWater = $assumptionsInput
        .children("div")
        .children("div.form-group")
        .children("select#dailyHotWater")
        .val();
      //requestParms.InstallationLocation = 'Indoors';
      requestParms.MobileHomeInstallation =
        $assumptionsInput
          .children("div")
          .children("div.form-group")
          .children("select#mobileHome")
          .val().toLowerCase() === "yes";
      // }
      // if (section.indexOf('localData') >= 0) {
      var $localDataInput = $("section.localDataInput");
      requestParms.AverageGroundWaterTemp = $localDataInput
        .children("div")
        .children("div.form-group")
        .children("input#avgGroundWaterTemp")
        .val();
      requestParms.WinterGroundWaterTemp = $localDataInput
        .children("div")
        .children("div.form-group")
        .children("input#winterGroundWaterTemp")
        .val();
      requestParms.Emmission = $localDataInput
        .children("div")
        .children("div.form-group")
        .children("select#emission")
        .val();
      requestParms.electricityPrice = $localDataInput
        .children("div")
        .children("div.form-group")
        .children("input#electricityPrice")
        .val();
      requestParms.naturalGasPrice = $localDataInput
        .children("div")
        .children("div.form-group")
        .children("input#naturalGasPrice")
        .val();
      requestParms.propanePrice = $localDataInput
        .children("div")
        .children("div.form-group")
        .children("input#propanePrice")
        .val();
      // }
    };

    var SetAdvancedModalValues = function SetAdvancedModalValues(section) {
      // if (section.indexOf('installation') >= 0) {
      var $installationText = $("section.installationText");
      var $installationInput = $("section.installationInput");
      //requestParms.zipCode = $installationInput.children('div.installationZipCode').children('input').val();
      var temp = "";
      temp = $('#venting').val();
      $installationText
        .children("div")
        .children("div")
        .children('h3:contains("Venting")')
        .next()
        .text(temp);
      switch (requestParms.energySource) {
        case "Electric":
          temp = "Electric";
          break;
        case "NaturalGas":
          temp = "Natural Gas";
          break;
        default:
          temp = "Propane";
          break;
      }
      $installationText
        .children("div")
        .children("div")
        .children('h3:contains("Power Source")')
        .next()
        .text(temp);
      temp =
        requestParms.spaceHeight +
        '" x ' +
        requestParms.spaceWidth +
        '" x ' +
        requestParms.spaceDepth +
        '"';
      $installationText
        .children("div")
        .children("div")
        .children('h3:contains("Available Space")')
        .next()
        .text(temp);
      var $assumptionsText = $("section.assumptionsText");
      var $assumptionsInput = $("section.assumptionsInput");
      //
      $assumptionsText
        .children("div")
        .children("div")
        .children('h3:contains("Shower Flow Rate")')
        .next()
        .text(requestParms.showerFlowRate + " gallons/minute");
      //
      $assumptionsText
        .children("div")
        .children("div")
        .children('h3:contains("Bathtub Flow Rate")')
        .next()
        .text(requestParms.BathTubFlowRate + " gallons/minute");
      //
      $assumptionsText
        .children("div")
        .children("div")
        .children('h3:contains("Tank Set Point")')
        .next()
        .text(requestParms.TankTemp + "°");
      //
      $assumptionsText
        .children("div")
        .children("div")
        .children('h3:contains("Average Air Temperature")')
        .next()
        .text(requestParms.AverageAirTemp + "°");
      //
      //$assumptionsText.children('div').children('div').children('h3:contains("Average Groundwater Temperature")').next().text(requestParms.AverageGroundWaterTemp + "°");
      //
      $assumptionsText
        .children("div")
        .children("div")
        .children('h3:contains("Average Hot Water Usage")')
        .next()
        .text(requestParms.DailyHotWater + " gallons");
      //
      if (requestParms.MobileHomeInstallation === true) {
        $assumptionsText
          .children("div")
          .children("div")
          .children('h3:contains("Mobile Home")')
          .next()
          .text("Yes");
      } else {
        $assumptionsText
          .children("div")
          .children("div")
          .children('h3:contains("Mobile Home")')
          .next()
          .text("No");
      }
      // }
      // if (section.indexOf('localData') >= 0) {
      var $localDataText = $("section.localDataText");
      var $localDataInput = $("section.localDataInput");
      //
      $localDataText
        .children("div")
        .children("div")
        .children('h3:contains("Cold Water (avg)")')
        .next()
        .text(requestParms.AverageGroundWaterTemp + "°");
      //
      $localDataText
        .children("div")
        .children("div")
        .children('h3:contains("Cold Water (winter)")')
        .next()
        .text(requestParms.WinterGroundWaterTemp + "°");
      //
      switch (requestParms.Emmission) {
        case "Low Nox":
          $localDataText
            .children("div")
            .children("div")
            .children('h3:contains("Emissions")')
            .next()
            .text("Low NOx");
          break;
        case "Ultra-Low Nox":
          $localDataText
            .children("div")
            .children("div")
            .children('h3:contains("Emissions")')
            .next()
            .text("Ultra-Low NOx");
          break;
        default:
          $localDataText
            .children("div")
            .children("div")
            .children('h3:contains("Emissions")')
            .next()
            .text("No Emissions Requirements");
          break;
      }
      //
      $localDataText
        .children("div")
        .children("div")
        .children('h3:contains("Electricity")')
        .next()
        .text("$" + requestParms.electricityPrice + "/kWh");
      //
      $localDataText
        .children("div")
        .children("div")
        .children('h3:contains("Natural Gas")')
        .next()
        .text("$" + requestParms.naturalGasPrice + "/Mcf");
      //
      $localDataText
        .children("div")
        .children("div")
        .children('h3:contains("Propane")')
        .next()
        .text("$" + requestParms.propanePrice + "/gallon");
      // }
    };

    $("#modalAdvancedOptions").on("hidden.bs.modal", function(e) {
      if (runRequest) {
        runRequest = false;
        sendGAPageView(
          "AdvancedResultsClosed",
          {
            advanded: true
          },
          "PST Widget Advanced Modal Closed"
        );
        SubmitRequest();
      }
    });

    var UpdatePricesFields = function UpdatePricesFields() {
      var $installationText = $("section.installationText");
      var $installationInput = $("section.installationInput");
      var temp = "";
      $installationText
        .children("div")
        .children("div")
        .children('h3:contains("Location")')
        .next()
        .text(
          resultsObj.prices.City === '' ?
          'National Averages' :
          resultsObj.prices.City +
          ", " +
          resultsObj.prices.State +
          " " +
          resultsObj.prices.ZipCode
        );
      $installationInput
        .children("div.installationZipCode")
        .children("input")
        .val(resultsObj.prices.ZipCode);
      //
      var $assumptionsText = $("section.assumptionsText");
      var $assumptionsInput = $("section.assumptionsInput");
      $assumptionsText
        .children("div")
        .children("div")
        .children('h3:contains("Average Groundwater Temperature")')
        .next()
        .text(MathRound(resultsObj.prices.AverageGroundWaterTemp, 3) + "°");
      $assumptionsInput
        .children("div")
        .children("div.form-group")
        .children("input#avgGroundWaterTemp")
        .val(MathRound(resultsObj.prices.AverageGroundWaterTemp, 3));
      //
      var $localDataText = $("section.localDataText");
      var $localDataInput = $("section.localDataInput");
      $localDataText
        .children("div")
        .children("div")
        .children('h3:contains("Cold Water (avg)")')
        .next()
        .text(MathRound(resultsObj.prices.AverageGroundWaterTemp, 3) + "°");
      $localDataInput
        .children("div")
        .children("div.form-group")
        .children("input#avgGroundWaterTemp")
        .val(MathRound(resultsObj.prices.AverageGroundWaterTemp, 3));
      $localDataText
        .children("div")
        .children("div")
        .children('h3:contains("Cold Water (winter)")')
        .next()
        .text(MathRound(resultsObj.prices.WinterGroundWaterTemp, 3) + "°");
      $localDataInput
        .children("div")
        .children("div.form-group")
        .children("input#winterGroundWaterTemp")
        .val(MathRound(resultsObj.prices.WinterGroundWaterTemp, 3));
      //
      switch (resultsObj.prices.Emission.toLowerCase()) {
        case "low nox":
          $localDataText
            .children("div")
            .children("div")
            .children('h3:contains("Emissions")')
            .next()
            .text("Low NOx");
          temp = "LowNox";
          break;
        case "ultra-low nox":
          $localDataText
            .children("div")
            .children("div")
            .children('h3:contains("Emissions")')
            .next()
            .text("Ultra-Low NOx");
          temp = "UltraLowNox";
          break;
        default:
          $localDataText
            .children("div")
            .children("div")
            .children('h3:contains("Emissions")')
            .next()
            .text("No Emissions Requirements");
          temp = "NoEmissionsRequirements";
          break;
      }
      window.UpdateLocalDataFields();

      AdvancedModalReset();
    };

    $('#modalAdvancedOptions').on('hidden.bs.modal', function (e) {
      // All other values get rerendered, zip needs to be updated
      $("#installationZipcode").val(resultsObj.prices.ZipCode);
    });

    $("#btnBack").click(function() {
      if (window.editWindowOpen) {
        $("section.advancedSliders").toggle();
        window.editWindowOpen = !window.editWindowOpen;
        AdvancedModalReset();
      } else {
        $("#modalAdvancedOptions").modal("hide");
      }
    });

    $("#btnApplyOptions").click(function(e) {
      if ($("section.installationText").hasClass("active")) {
        // take everything but the zipcode of the values and update the requetParms
        SetSubmitRequestValues("installation");
        SetAdvancedModalValues("installation");
        // if zipcode changed, run ajax->prices and update effected fields in success method
        var $installationInput = $("section.installationInput");
        var height = $installationInput.find("#installationSpaceHResult").val();
        var width = $installationInput.find("#installationSpaceWResult").val();
        var depth = $installationInput.find("#installationSpaceDResult").val();
        var venting = $installationInput.find("#venting").val();
        resultsObj.request.TankHeight = height;
        resultsObj.request.TankWidth = width;
        resultsObj.request.TankDiameter = depth;
        resultsObj.request.VentType = venting;
        requestParms.ventingPreference = venting;
        var zipcode = $installationInput.find("#installationZipcode").val();
        if (zipcode != requestParms.zipCode) {
          requestParms.zipCode = zipcode;
          requestParms.AverageGroundWaterTemp = 0;
          requestParms.WinterGroundWaterTemp = 0;
          requestParms.electricityPrice = 0;
          requestParms.naturalGasPrice = 0;
          requestParms.propanePrice = 0;
          sendGAPageView(
            "AdvancedResults",
            {
              advanded: true
            },
            "PST Widget Advanced Modal"
          );
          SubmitRequest(false, UpdatePricesFields);
          //return;
        } else {
          sendGAPageView(
            "AdvancedResults",
            {
              advanded: true
            },
            "PST Widget Advanced Modal"
          );
          SubmitRequest();
        }
        AdvancedModalReset();
      } else if ($("section.assumptionsText").hasClass("active")) {
        // take the rest of the values and update the requetParms
        SetSubmitRequestValues("assumptions");
        SetAdvancedModalValues("assumptions");
        sendGAPageView(
          "AdvancedResults",
          {
            advanded: true
          },
          "PST Widget Advanced Modal"
        );
        SubmitRequest();
        AdvancedModalReset();
      } else if ($("section.localDataText").hasClass("active")) {
        // take the rest of the values and update the requetParms
        SetSubmitRequestValues("localData");
        SetAdvancedModalValues("localData");
        sendGAPageView(
          "AdvancedResults",
          {
            advanded: true
          },
          "PST Widget Advanced Modal"
        );
        SubmitRequest();
        AdvancedModalReset();
      } else {
        // this means they hit apply options to close the modal
        // set global var to true and run ajax->request on modal close
        runRequest = true;
        $("#modalAdvancedOptions").modal("hide");
      }
      $("section.advancedSliders").show();
    });

    var scrollToOffset = 0;
    $("#advYourInstallationEdit,#advAssumptionsEdit,#advLocalDataEdit").click(
      function(e) {
        $("#meets_your_needs").addClass("active");
        $("#more_hot_water").removeClass("active");
        $("#low_energy_cost").removeClass("active");
        window.editWindowOpen = true;
        scrollToOffset = $("#" + this.id).position().top;
        $("section.advancedSliders").hide();
        $("section.installationText")
          .hide()
          .removeClass("active");
        $("section.assumptionsText")
          .hide()
          .removeClass("active");
        $("section.localDataText")
          .hide()
          .removeClass("active");
        $("#" + this.id)
          .parent()
          .parent()
          .next()
          .show();
        $("#" + this.id)
          .parent()
          .parent()
          .addClass("active");
        $("#modalAdvancedOptions > div > div > div.modal-footer").show();
        if (inProductPage) {
          $(".notOnProductPageInput").hide();
          $("#mobileHome")
            .parent()
            .hide();
          $("#emission")
            .parent()
            .hide();
        } else {
          $(".notOnProductPageInput").show();
          $("#mobileHome")
            .parent()
            .show();
          $("#emission")
            .parent()
            .hide();
        }
        $("#btnApplyOptions").show();
        $("#btnApplyOptions").text("Save");
        $(".cancel-footer-button")
          .parent()
          .removeClass("inline-btn-center")
          .removeClass("col-sm-12")
          .removeClass("col-md-12")
          .addClass("col-md-6")
          .addClass("col-sm-6");
        $("#modalAdvancedOptions div.modal-dialog div.modal-content").animate(
          {
            scrollTop: "0px"
          },
          250
        );
      }
    );

    $(".cancel-footer-button").click(function(e) {
      if (
        $("section.installationText").hasClass("active") ||
        $("section.assumptionsText").hasClass("active") ||
        $("section.localDataText").hasClass("active")
      ) {
        AdvancedModalReset();
      } else {
        runRequest = false;
        $("#modalAdvancedOptions").modal("hide");
        //$('button.modalAdvancedOptions').hide();
      }
      $("section.advancedSliders").toggle();
    });

    var AdvancedModalReset = function AdvancedModalReset(first) {
      if (typeof first != "undefined") {
        first = false;
        scrollToOffset = 0;
      }
      $("#btnApplyOptions").text("Apply Options");
      $("section.advancedSliders").show();
      $("section.installationText")
        .show()
        .removeClass("active");
      $("section.installationInput")
        .hide()
        .removeClass("active");
      $("section.assumptionsText")
        .show()
        .removeClass("active");
      $("section.assumptionsInput")
        .hide()
        .removeClass("active");
      $("section.localDataText")
        .show()
        .removeClass("active");
      $("section.localDataInput")
        .hide()
        .removeClass("active");
      // if (!showFooter)
      //     $('#modalAdvancedOptions > div > div > div.modal-footer').hide();
      // else {
      $("#modalAdvancedOptions > div > div > div.modal-footer").show();
      $("#btnApplyOptions").hide();
      $(".cancel-footer-button")
        .parent()
        .removeClass("col-md-6")
        .removeClass("col-sm-6")
        .addClass("inline-btn-center")
        .addClass("col-sm-12")
        .addClass("col-md-12");
      // }
      var inMobile = $("#is-mobile").length > 0;
      var advSlidersOffet = 0;
      // if (!inMobile) {
      //     $('section.advancedSliders').hide();
      // } else {
      //     $('section.advancedSliders').show();
      // }
      if (!inMobile) {
        $("#modalAdvancedOptions div.modal-dialog div.modal-content").animate(
          {
            scrollTop: scrollToOffset + "px"
          },
          250
        );
      } else {
        var $advModalSurface = $(
          "#modalAdvancedOptions div.modal-dialog div.modal-content"
        );
        // var overflowYsave = $('body,html').css('overflow-y');
        // $('body,html').css('overflow-y', 'hidden');
        $advModalSurface.scrollTop(0);
        // $('body,html').css('overflow-y', overflowYsave);
      }
    };
  });

  function sendGAPageView(root, extraParams, title) {
    var userParams = {
      ID: userPreferences.userID,
      brandid: userPreferences.brandid
    };
    var allFields = $.extend({}, userParams, requestParms, extraParams, {
      price: requestParms.price
    });
    var fullQuery = encodeURIComponent($.param(allFields));
    ga("send", {
      hitType: "pageview",
      page: "/" + root + "?" + fullQuery,
      title: title
    });
  }
})(window.jQuery, window, document);

(function() {
  "strict mode";

  $(function() {
    var dangerTemp = 135,
      $tankWaterTemp = $("#tankWaterTemp"),
      $agreeCheckbox = $("#agreeTemp"),
      $saveButton = $("#btnApplyOptions");

    //Restrict Input to upper value specificed on data-max
    //On keyup we can change the value to be less than the max
    $("[data-max]").on("keyup change", function() {
      var $this = $(this);
      var userSetting = $this.val();
      limitUpperInputValue(userSetting, $this.data("max"), $this);
    });

    //Restrict Input to lower value specificed on data-min
    //For the min limit we need to wait until they are done typing
    $("[data-min]").on("change", function() {
      var $this = $(this);
      var userSetting = $this.val();
      limitLowerInputValue(userSetting, $this.data("min"), $this);
    });

    //Handle Too High Tank Temp Warning Message
    $tankWaterTemp.on("keyup click", function(e) {
      checkUserInputForWarning($(this).val());
    });

    $("#modalAdvancedOptions").on("show.bs.modal", function(e) {
      checkUserInputForWarning($tankWaterTemp.val());
    });

    $agreeCheckbox.on("change", function(e) {
      $saveButton.prop("disabled", !userHasAgreed());
    });

    function checkUserInputForWarning(value) {
      if (value > dangerTemp) {
        displayWarning(value);
      } else {
        hideWarning();
      }
    }

    function displayWarning(temp) {
      $tankWaterTemp.addClass("warning");
      $agreeCheckbox.prop("checked", false);
      $saveButton.prop("disabled", true);
      $("#tempVal").text(temp);
      $(".temp-warning").show();
    }

    function hideWarning() {
      $saveButton.prop("disabled", false);
      $tankWaterTemp.removeClass("warning");
      $(".temp-warning").hide();
    }

    function userHasAgreed() {
      return $("#agreeTemp:checked").length > 0;
    }

    //Do upper and lower limit seperatle since we check them on differnt events
    //Upper limit checked on keyup
    function limitUpperInputValue(val, max, $node) {
      val = val > max ? max : val;
      $node.val(val);
      return val;
    }

    //Lower limit checked on change
    function limitLowerInputValue(val, min, $node) {
      val = val < min || !val ? min : val;
      $node.val(val);
      return val;
    }
  });
})();
